<template>
	<inertia-head title="Upgrade/Renew" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Upgrade/Renew Membership</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Enjoy more benefits when you upgrade your TRC Account!
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div
		v-if="flash && flash.message"
		class="alert alert-dismissible shadow"
		:class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'"
		role="alert"
	>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="alert"
			aria-label="Close"
		></button>
		<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
		<p class="mb-0">
			{{ flash.message }}
		</p>
	</div>

	<div v-if="$page.props.user.qualified_for_pf=='Yes'">
		<div class="shadow m-3 border border-default bg-white" :class="{'text-danger':!unimember.is_pf}">
			<div class="content">
				<h4 v-if="!unimember.is_pf" class="text-center">You are qualified to PLATINUM FAITHFUL upgrade</h4>
				<h4 v-if="unimember.is_pf" class="text-center"><p>Thank you for confirming your <span class="text-success">PLATINUM FAITHFUL</span> membership. Please click the button below for the details of recurring charges.</p></h4>
			</div>
		</div>
		<div v-if="!unimember.is_pf" class="content">
			<div class="row">
				<div class="col-12">
					<div class="block block-rounded shadow">
						<div class="block-content">
							<div class="h4 border-bottom py-1">PLATINUM FAITHFUL</div>
						</div>
						<div class="block-content small">
							<p>Give What You Want To Give From Your Heart</p>
							<div class="row">
								<div class="col-12">
									<div class="my-5 embed-responsive">
										<iframe class="embed-responsive-item" src="https://player.vimeo.com/video/522616960"
											frameborder="0"
											allow="autoplay; fullscreen; picture-in-picture"
											allowfullscreen
										></iframe>
									</div>
								</div>
							</div>
							<p>If you found this page, that means you’re very special to me.</p>
							<p>That means you’re a faithful Platinum Member that now has a lasting place in our Platinum family. May I propose something? Instead of you giving the usual Platinum Membership fee, just give what you want to give.</p>
							<p>I repeat what I said in my letter to you: I love you. I know that sounds so unprofessional and non-business-like, but I’m not afraid to show my feelings.</p>
							<p>After being together for years, our relationship is now permanent. So the exact fees no longer matter. Just give what you feel you want to give, based on (1) whatever blessings you receive from the Platinum Family, plus (2) how much you want to contribute to my mission and ministry work. (Note: You don’t even have to give anything. I love you unconditionally.)</p>
							<p>Note: This arrangement is NOT for everyone. Obviously, new people who want to join Platinum will have to give the usual membership fees. This is exclusively for you and our Platinum friends who have been faithfully with us for a number of years.</p>
							<p>To to this just click on the button below.</p>
							<p>Once again, I want you to know that our friendship has meant so much to me.</p>
							<p>Thank you for being God’s amazing blessing to my life.</p>
							<p>May you become Truly Rich,</p>
							<p>Bo Sanchez</p>
							<div class="my-5">
								<button @click="pfToggleModal" class="btn btn-lg btn-alt-primary py-3">CLICK HERE TO UPGRADE YOUR ACCOUNT</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="row">
			<div class="col-md-6 m-auto">
				<div class="block block-rounded shadow text-center">
					<div class="block-header">
						<h3 class="block-title">CURRENT SUBSCRIPTION</h3>
					</div>
					<div class="block-content bg-info-light">
						<div class="h3 fw-bold mb-0">
							{{ unimember.rank }}
						</div>
						<div class="fs-sm fw-semibold mb-3">
							Expiry: {{ unimember.expiry }}
						</div>
					</div>
					<div v-if="!unimember.is_pf" class="block-content">
						<div class="row">
							<div class="col-xl-12">
								<div class="row">
									<div class="col-6">
										<div class="form-check form-block mb-4">
											<input
												v-model="payment_method"
												class="form-check-input"
												type="radio"
												:value="'CARD'"
												id="card"
												name="payment_method"
											/>
											<label class="form-check-label" for="card">
												<span
													class="d-flex align-items-center"
													style="
														background-image: url(/media/logo/stripe-logo.png);
														background-size: contain;
														background-repeat: no-repeat;
														background-position: center;
														height: 100px;
													"
												>
												</span>
											</label>
										</div>
									</div>
									<div class="col-6">
										<div class="form-check form-block mb-4">
											<input
												v-model="payment_method"
												class="form-check-input"
												type="radio"
												:value="'DRAGONPAY'"
												id="dragonpay"
												name="payment_method"
											/>
											<label class="form-check-label" for="dragonpay">
												<span
													class="d-flex align-items-center"
													style="
														background-image: url(/media/logo/dragonpay-logo.png);
														background-size: contain;
														background-repeat: no-repeat;
														background-position: center;
														height: 100px;
													"
												>
												</span>
											</label>
										</div>
									</div>
									<!-- <div class="col-4">
										<div class="form-check form-block mb-4">
											<input
												v-model="payment_method"
												class="form-check-input"
												type="radio"
												:value="'BROPAY'"
												id="bropay"
												name="payment_method"
											/>
											<label class="form-check-label" for="bropay">
												<span
													class="d-flex align-items-center"
													style="
														background-image: url(/media/logo/bropay-logo.png);
														background-size: contain;
														background-repeat: no-repeat;
														background-position: center;
														height: 100px;
													"
												>
												</span>
											</label>
										</div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
					<div
						class="block-content block-content-full block-content-sm text-center"
					>
						<div class="mb-4">
							<div class="space-x-2">
								<div class="form-check form-check-inline">
									<input
										v-model="action"
										class="form-check-input"
										type="radio"
										id="example-radios-inline1"
										name="example-radios-inline"
										value="renew"
									/>
									<label
										class="form-check-label fw-semibold"
										for="example-radios-inline1"
									>
										RENEW
									</label>
								</div>
								<div
									v-if="!['PLATINUM','PLATINUM COUPLE','PLATINUM FAITHFUL'].includes(unimember.rank)"
									class="form-check form-check-inline"
								>
									<input
										v-model="action"
										class="form-check-input"
										type="radio"
										id="example-radios-inline2"
										name="example-radios-inline"
										value="upgrade"
									/>
									<label
										class="form-check-label fw-semibold"
										for="example-radios-inline2"
									>
										UPGRADE
									</label>
								</div>
							</div>
						</div>
						<button
							@click="toggleModal"
							type="button"
							class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
							data-toggle="click-ripple"
						>
							Continue <i class="fa fa-arrow-right ms-2"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="$page.props.user.qualified_for_pf=='Yes' && !unimember.is_pf">
		<upgrade-renew-modal
			:key="new Date().getTime().toString()+'_pf'"
			ref="pfModal"
			:test="test"
			action="pf_upgrade"
			:unimember="unimember"
			:subscriptions="subscriptions"
			payment_method="CARD"
		/>
	</div>

	<upgrade-renew-modal
		:key="new Date().getTime().toString()"
		ref="upgradeRenewModal"
		:test="test"
		:action="action"
		:unimember="unimember"
		:subscriptions="subscriptions"
		:payment_method="payment_method"
	/>

</template>
<script>
import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../Layouts/AuthLayout';
import UpgradeRenewModal from '../../Shared/Components/Modals/UpgradeRenewModal';
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		test 				: String,
		action 				: String,
		unimember 			: Object,
		subscriptions 		: Object,
		api_response 		: Object,
		flash 				: Object
	},
	components: {
		UpgradeRenewModal,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const action = ref(props.action)

		const payment_method = ref('CARD')

		const upgradeRenewModal = ref(null)
		const pfModal 			= ref(null)

		const toggleModal = () => {
			upgradeRenewModal.value.toggleModal()
		}

		const pfToggleModal = () => {
			pfModal.value.toggleModal()
		}

		watch(action, (value) => {
			Inertia.get(
				route('member.upgrade-renew'),
				{ action: value },
				{
					preserveState: true,
					preserveScroll: true,
					only: ['subscriptions', 'action'],
				}
			)
		})


		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				if(value.result=="success")
				{
					toast.show("Successfully updated", { type: value.result});
				}else
				{
					toast.show("Failed to update", { type: "error"});
				}
			}
		})

		return {
			toast,
			action,
			toggleModal,
			pfToggleModal,
			payment_method,
			upgradeRenewModal,
			pfModal
		}
	},
}
</script>
